






























import { defineComponent, computed } from '@vue/composition-api'
import { VMenu, VBtn, VList, VListItem } from 'vuetify/lib'
import BaseIcon from './BaseIcon.vue'

export default defineComponent({
  inheritAttrs: false,
  props: {
    label: String,
    iconName: String,
    items: Array,
    btnAriaLabel: String
  },
  components: {
    VMenu,
    VBtn,
    BaseIcon,
    VList,
    VListItem
  },
  setup (props) {
    const menuItems = computed(() => props.items ? props.items.filter((item: any) => item.visible) : [])

    return { menuItems }
  }
})
